import { render, staticRenderFns } from "./MetadataByRule.vue?vue&type=template&id=1b1a56ce&"
import script from "./MetadataByRule.vue?vue&type=script&lang=js&"
export * from "./MetadataByRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports